import React from "react";
import { Alert, Checkbox, Modal, Select, Space, Tag, Typography } from "antd";

export const channelLabel = selection => selection?.channel?.label || selection?.label || selection?.channel?.key || selection?.key || "Not set";
export const channelKey = selection => selection?.channel?.key || selection?.key || null;

export function CommunicationChannelTag({ selection, showMode = false }) {
  const key = channelKey(selection);
  const automated = selection?.channel?.is_automated ?? selection?.is_automated;
  return <Space size={6} wrap><Tag color={key === "wati" ? "green" : key ? "blue" : "default"}>{channelLabel(selection)}</Tag>{showMode && key && <Typography.Text type="secondary">{automated ? "Automated" : "Manual"}</Typography.Text>}</Space>;
}

export function QueryCreationChannelModal({ open, channels, loading, customerDefault, onContinue }) {
  const existingKey = channelKey(customerDefault);
  const [selectedKey, setSelectedKey] = React.useState(null);
  const [setAsDefault, setSetAsDefault] = React.useState(false);

  React.useEffect(() => {
    if (!open) return;
    setSelectedKey(existingKey);
    setSetAsDefault(!existingKey);
  }, [open, existingKey]);

  const differs = !!selectedKey && selectedKey !== existingKey;
  const showCheckbox = !existingKey || differs;
  const savesDefault = showCheckbox && setAsDefault;

  return <Modal
    open={open}
    title="Choose customer communication channel"
    closable={false}
    maskClosable={false}
    keyboard={false}
    cancelButtonProps={{ style: { display: "none" } }}
    okText="Save & Continue"
    okButtonProps={{ disabled: !selectedKey || loading }}
    confirmLoading={loading}
    onOk={() => onContinue({ communication_channel_key: selectedKey, set_as_customer_default: !!savesDefault })}
  >
    <Space direction="vertical" size={14} style={{ width: "100%" }}>
      <Typography.Text>This channel applies to communication with the customer for this query. It does not affect supplier communication.</Typography.Text>
      <Select
        autoFocus
        value={selectedKey}
        loading={loading}
        placeholder="Select a communication channel"
        style={{ width: "100%" }}
        onChange={value => { setSelectedKey(value); if (existingKey && value !== existingKey) setSetAsDefault(false); }}
        options={(channels || []).map(channel => ({ value: channel.key, label: channel.label }))}
      />
      {existingKey && !differs && <Alert showIcon type="info" message="This is the customer’s default preferred communication channel." />}
      {showCheckbox && <Checkbox checked={setAsDefault} onChange={event => setSetAsDefault(event.target.checked)}>Make this the customer’s default preferred channel for all future query communications.</Checkbox>}
      {savesDefault && <Alert showIcon type="info" message="This will be saved as the default preferred communication channel for the customer for every query from now on." />}
    </Space>
  </Modal>;
}

